export const CreateButton = "Create event button";
export const ViewLiveEventType = "View active event type";
export const AccessTimeline = "Access to timeline";
export const AccessEditButton = "Access edit button";
export const FlightScheduleButton = "Flt sched button";
export const ViewManageTab = "View manage tab";
export const ViewMoreTab = "View more tab";
export const CloseEventPermission = "Close event";
export const EditProblemStatement = "Edit problem statement";
export const EditOTS_StartTime="Edit OTS start time";
export const EditADVETRTime = "Edit ADV/ETR time";
export const EditLocation = "Edit location";
export const EditStation = "Edit station";
export const EditATACode = "Edit ATA code";
export const AddComment = "Add comment";
export const CreateButtonFleetType = "Create event by fleet type button";
export const ViewAogPartsTab ="View aog parts tab";

